import styled from '@emotion/styled';
import React, { useState } from 'react';

const StyledImage = styled.img<{ maxWidth?: string }>`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: ${({ maxWidth }) => maxWidth || '100%'};
    cursor: pointer;
    transition: opacity 0.5s ease-in-out;

    &:hover {
        opacity: 0.8;
    }
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    cursor: pointer;
`;

const ExpandedImage = styled.img`
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
`;

const Placeholder = styled.div<{ maxWidth?: string }>`
    width: 100%;
    max-width: ${({ maxWidth }) => maxWidth || '100%'};
    height: 200px;
    background: linear-gradient(90deg, #f8f8f8 25%, #ececec 50%, #f8f8f8 75%);
    background-size: 200% 100%;
    animation: slide-animation 2s infinite;
    border-radius: 10px;
    border: 3px solid #f3f3f3;

    @keyframes slide-animation {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;

interface ItemImageProps {
    src?: string;
    alt?: string;
    className?: string;
    maxWidth?: string;
    'data-testid'?: string;
}

const ItemImage: React.FC<ItemImageProps> = ({ src, alt, className, maxWidth, 'data-testid': dataTestId }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    if (!src) return null;

    return (
        <>
            {!isLoaded && <Placeholder maxWidth={maxWidth} />}
            <StyledImage
                src={src}
                alt={alt}
                className={className}
                maxWidth={maxWidth}
                data-testid={dataTestId}
                onClick={() => isLoaded && setIsExpanded(true)}
                onLoad={() => setIsLoaded(true)}
                style={{ opacity: isLoaded ? 1 : 0, position: isLoaded ? 'static' : 'absolute' }}
            />
            {isExpanded && (
                <Overlay onClick={() => setIsExpanded(false)}>
                    <ExpandedImage src={src} alt={alt} />
                </Overlay>
            )}
        </>
    );
};

export { ItemImage };
